import { useEffect, useState } from "react";
import { avisosApi } from "./avisos.service";
import { push } from "../navigation/v2/sales/push";

/**
 * El número de avisos sin leer (lo arranca AvisosEnVivo). Una sola consulta para la pestaña: al entrar, con el aviso al instante
 * (evento "aviso" de wapp-push), al volver a la pestaña y cada minuto de respaldo.
 */
let valor = 0;
const oyentes = new Set<(n: number) => void>();
let activo = false;
let espera: any = null;
let ultima = 0;

const publicar = (n: number) => { valor = n; oyentes.forEach((fn) => fn(n)); };

export const refrescarConteo = (ms = 300) => {
	if (!activo || espera) return;
	espera = setTimeout(async () => {
		espera = null;
		try { publicar(Number((await avisosApi.conteo()).data.no_leidos) || 0); ultima = Date.now(); } catch { /* se queda el de antes */ }
	}, ms);
};

export const ponerConteo = (n: number) => publicar(Math.max(0, n));

/** conPush: abre (o comparte) la conexión de wapp-push; sin ella, cada minuto. */
export const iniciarConteo = (campusId: number, conPush: boolean): (() => void) => {
	activo = true;
	const soltar = conPush ? push.usar(campusId) : () => undefined;
	const quitar = push.on("aviso", () => refrescarConteo(500));
	// Al volver solo si lo último tiene más de 30 s; el respaldo, cada minuto sin conexión al instante y cada 3 con ella
	// (el aviso nuevo llega por wapp-push; 12-oct-2026: ~190 consultas/min en hora pico solo por el respaldo).
	const alVolver = () => { if (document.visibilityState === "visible" && Date.now() - ultima > 30000) refrescarConteo(200); };
	document.addEventListener("visibilitychange", alVolver);
	const ciclo = setInterval(() => {
		if (document.visibilityState === "visible" && Date.now() - ultima > (push.conectado ? 175000 : 55000)) refrescarConteo(0);
	}, 60000);
	refrescarConteo(0);
	return () => {
		activo = false;
		soltar(); quitar();
		document.removeEventListener("visibilitychange", alVolver);
		clearInterval(ciclo);
		clearTimeout(espera); espera = null;
		publicar(0);
	};
};

export const useConteoAvisos = (): number => {
	const [n, setN] = useState(valor);
	useEffect(() => { oyentes.add(setN); setN(valor); return () => { oyentes.delete(setN); }; }, []);
	return n;
};
